import React from 'react';
import Text from '@/components/Typography/Text';
import PropTypes from 'prop-types';

export default function Paragraph({ 
  children,
  color = 'primary',
  style,
  ...props 
}) {
  return (
    <Text 
      size="n"
      weight="normal"
      color={color}
      style={[
        {
          marginBottom: 16,
          lineHeight: 24,
        },
        style,
      ]} 
      {...props}
    >
      {children}
    </Text>
  );
}

Paragraph.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'alt']),
  style: PropTypes.object,
};
